export enum SubscriptionRoutesEnum {
  ROOT = "/subscriptions",
  "SUBSCRIPTION_ID" = "/subscriptions/:subscriptionId/program/:programId",
  PLANS = "/subscriptions/program/:programId",
  BLA = "/subscriptions/:subscriptionId/program/:programId/BLA",
  "BLA_ONBOARDING" = "/subscriptions/:subscriptionId/program/:programId/BLA/start",
  "BLA_END" = "/subscriptions/:subscriptionId/program/:programId/BLA/end",
  PHQ = "/subscriptions/:subscriptionId/program/:programId/BLA/PHQ",
}

export enum SubscriptionPathsEnum {
  ROOT = "subscriptions",
  SUBSCRIPTION_ID = ":subscriptionId/program/:programId",
  PLANS = "program/:programId",
  BLA = ":subscriptionId/program/:programId/BLA",
  BLA_ONBOARDING = ":subscriptionId/program/:programId/BLA/start",
  BLA_END = ":subscriptionId/program/:programId/BLA/end",
  PHQ = ":subscriptionId/program/:programId/BLA/PHQ",
}
